import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Create a custom theme with proper dark mode text colors
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: true,
  },
  styles: {
    global: (props) => ({
      body: {
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
      },
      // Ensure table text is visible in dark mode
      'table tbody td': {
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.200',
      },
      'table thead th': {
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.200',
      },
      'table tr': {
        borderBottomWidth: '1px',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.200',
      }
    }),
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {console.log('Google Client ID:', process.env.REACT_APP_GOOGLE_CLIENT_ID)}
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
